import f from '@qnpm/react-native-ext-fetch';
import getClientJson from './getClientJson';

// 全局请求拦截，如果发现状态码是登录实现，则自动唤起登录
// f.response((res) => {
//     const { status } = res;
//     if (invalidLoginCodeMap[status]) {
//         loginUtil.delayLogin();
//     }
//     return res;
// });

const defaultParams = {
    withCredentials: true,
    responseType: 'json',
    body: {}
};

const fetch = async (options: any, getAbort?: any) => {
    const requestParams = {
        ...defaultParams,
        ...options
    };
    // console.log(requestParams);
    let clientJson;
    try {
        clientJson = JSON.stringify(await getClientJson());
    } catch (err) {
        clientJson = JSON.stringify({});
    }
    requestParams.body = requestParams.body || {};
    requestParams.body.clientJson = clientJson;

    const promise = f(requestParams);
    // 下发abort函数
    if (getAbort) {
        getAbort(() => {
            return promise.cancel('abort');
        });
    }
    return new Promise((resolve, reject) => {
        promise
            .then((res: any) => {
                // console.log(res);
                // QRN EXT 提供的qFetch 在接口404的情况下不会throw error
                if (res.ok === false) {
                    reject(new Error(res.statusText));
                } else {
                    resolve(res);
                }
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};
// global.$fetch = $fetch;
export { fetch };
